import { useEffect, useMemo, useState } from 'react'

import CustomFieldRender from '../../../../../../components/CustomFieldRender'
import { useGetFieldOptionRelationshipsQuery } from '../../services/field'
import { evaluateRequired } from '../CustomFields/helpers/requiredRule'

export function CustomField({ field, value, setValues, errors, isReadOnly, groupFields, formValues, fieldsById }) {
  const [mainOption, setMainOption] = useState(null)

  const { data: relationships } = useGetFieldOptionRelationshipsQuery(
    { mainOptionId: mainOption?.optionId },
    { skip: !mainOption?.optionId }
  )

  const isDataSourceField = !!field.fieldProperties?.dataSource

  const isRequired = useMemo(() => evaluateRequired(field, formValues, fieldsById), [field, formValues, fieldsById])

  const renderField = useMemo(
    () => ({
      ...field,
      requiredField: isRequired
    }),
    [field, isRequired]
  )

  useEffect(
    function setRelationships() {
      if (relationships && mainOption) {
        let values = { [field.internalFieldName]: mainOption.value }

        relationships.forEach(function ({ formFieldId, relatedOptionId }) {
          const { internalFieldName, fieldProperties } = groupFields.find(({ id }) => id === formFieldId)
          const relatedOptionValue = fieldProperties.options.find(({ id }) => id === relatedOptionId).value
          values[internalFieldName] = relatedOptionValue
        })

        setValues(values)
        setMainOption(null)
      }
    },
    [relationships]
  )

  // Preenche automaticamente os campos filhos que declaram este campo como fonte
  // (dataSourceFieldId), com base na coluna configurada (dataSourceColumn).
  function autofillFromDataSource(selectedValue) {
    const values = { [field.internalFieldName]: selectedValue }

    const selectedOption = selectedValue
      ? (field.fieldProperties.options || []).find((option) => option.value === selectedValue)
      : null

    groupFields
      .filter((dependent) => dependent.dataSourceFieldId === field.id && dependent.dataSourceColumn)
      .forEach((dependent) => {
        values[dependent.internalFieldName] = selectedOption ? selectedOption[dependent.dataSourceColumn] : undefined
      })

    setValues(values)
  }

  async function onChangeValue(fieldName, value) {
    if (isDataSourceField) {
      autofillFromDataSource(value)
      return
    }

    if (field.hasRelationships && value) {
      const optionId = field.fieldProperties.options.find((option) => option.value === value).id
      setMainOption({ optionId, value })
    } else {
      setValues({ [fieldName]: value })
    }
  }

  return (
    <CustomFieldRender
      enable={isReadOnly}
      disabled={isReadOnly}
      value={{ [field.internalFieldName]: value }}
      field={renderField}
      errors={errors}
      setFieldValue={onChangeValue}
    />
  )
}
